// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.skill-tile__unapproved-text a {\n  color: #000;\n  text-decoration: underline;\n}\n.skill-tile__qualification b {\n  color: #000;\n  font-weight: normal;\n}\n", ""]);
// Exports
module.exports = exports;
